<template>
    <div class="difficulty-progress-wrapper">
      <h3 class="title">Problem Difficulty</h3>
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div class="bar easy" :style="{ width: easyPct + '%' }"></div>
          <div class="bar medium" :style="{ width: mediumPct + '%' }"></div>
          <div class="bar hard" :style="{ width: hardPct + '%' }"></div>
        </div>
        <div class="legend">
          <div class="legend-item">
            <span class="dot easy"></span> Easy ({{ easy }})
          </div>
          <div class="legend-item">
            <span class="dot medium"></span> Medium ({{ medium }})
          </div>
          <div class="legend-item">
            <span class="dot hard"></span> Hard ({{ hard }})
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ProblemDifficultyProgress',
    data() {
      return {
        easy: 33,
        medium: 21,
        hard: 15
      }
    },
    computed: {
      total() {
        return this.easy + this.medium + this.hard
      },
      easyPct() {
        return ((this.easy / this.total) * 100).toFixed(1)
      },
      mediumPct() {
        return ((this.medium / this.total) * 100).toFixed(1)
      },
      hardPct() {
        return ((this.hard / this.total) * 100).toFixed(1)
      }
    }
  }
  </script>
  
  <style scoped>
  .difficulty-progress-wrapper {
    flex: 1 1 48%;
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  }

  
  
  .title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #333;
    text-align: center;
  }
  
  .progress-bar-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .progress-bar {
    display: flex;
    height: 24px;
    border-radius: 12px;
    overflow: hidden;
    width: 100%;
    background: #f1f1f1;
    border: 1px solid #ddd;
  }
  
  .bar {
    height: 100%;
  }
  
  .bar.easy {
    background-color: #4caf50;
  }
  
  .bar.medium {
    background-color: #ff9800;
  }
  
  .bar.hard {
    background-color: #f44336;
  }
  
  .legend {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 14px;
    color: #555;
  }
  
  .legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
  }
  
  .dot.easy {
    background-color: #4caf50;
  }
  
  .dot.medium {
    background-color: #ff9800;
  }
  
  .dot.hard {
    background-color: #f44336;
  }
  </style>
  